import { useQuery } from 'react-query'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getSalesTeamsUsers } from '@user/store/salesTeam'

export const useGetEligibleUsersForSalesTeams = (salesTeamsIds: number[]) => {
  const dispatch = useAppDispatch()
  const { data, ...rest } = useQuery(
    ['filters', 'shared', 'ownersForSalesTeams', salesTeamsIds],
    async () => {
      if (salesTeamsIds && salesTeamsIds.length > 0) {
        await dispatch(getSalesTeamsUsers(salesTeamsIds))
      }
    },
    {
      cacheTime: 0,
    },
  )

  return rest
}
